import * as util from "./util.js";
import * as cconst from "./const.js";

export const RADIUS_CURVE = {
  points: [
    { 0: 0, 1: 0, eid: 1, flag: 0, deg: 3, tangent: 1 },
    { 0: 0.33750000000000024, 1: 0, eid: 3, flag: 0, deg: 3, tangent: 1 },
    { 0: 0.7812500000000002, 1: 0.24375000000000002, eid: 5, flag: 1, deg: 3, tangent: 1 },
    { 0: 1, 1: 1, eid: 4, flag: 0, deg: 3, tangent: 1 },
    { 0: 1, 1: 1, eid: 2, flag: 0, deg: 3, tangent: 1 },
  ],
  deg: 3,
  eidgen: { _cur: 6 },
};
export const TONE_CURVE = {
  points: [
    { 0: 0.04375, 1: 0, eid: 68, flag: 1, deg: 3, tangent: 1 },
    { 0: 0.2062500000000003, 1: 0.16874999999999962, eid: 102, flag: 0, deg: 3, tangent: 1 },
    { 0: 0.38750000000000007, 1: 0.5375000000000001, eid: 114, flag: 0, deg: 3, tangent: 1 },
    { 0: 0.6687499999999995, 1: 0.7500000000000001, eid: 107, flag: 0, deg: 3, tangent: 1 },
    { 0: 0.975, 1: 0.7625000000000001, eid: 117, flag: 0, deg: 3, tangent: 1 },
    { 0: 1, 1: 1, eid: 96, flag: 0, deg: 3, tangent: 1 },
  ],
  eidgen: { _cur: 118 },
};
export const GREEN_VOIDCLUSTER_CURVE = {
  points: [
    { 0: 0, 1: 0, eid: 40, flag: 0, deg: 3, tangent: 1 },
    { 0: 0.1812499999999999, 1: 0.2062499999999997, eid: 50, flag: 1, deg: 3, tangent: 1 },
    { 0: 0.4625, 1: 0.03125, eid: 47, flag: 0, deg: 3, tangent: 1 },
    { 0: 0.81875, 1: 0.2562500000000001, eid: 48, flag: 0, deg: 3, tangent: 1 },
    { 0: 0.9125000000000002, 1: 0.59375, eid: 42, flag: 0, deg: 3, tangent: 1 },
    { 0: 1, 1: 0.9999999999999998, eid: 12, flag: 0, deg: 3, tangent: 1 },
    { 0: 1, 1: 1, eid: 2, flag: 0, deg: 3, tangent: 1 },
  ],
  deg: 3,
  eidgen: { _cur: 51 },
};
export const FFT_CURVE = {
  points: [
    { 0: 0, 1: 0, eid: 1, flag: 0, deg: 3, tangent: 1 },
    { 0: 0.2, 1: 0, eid: 5, flag: 0, deg: 3, tangent: 1 },
    { 0: 0.36875000000000036, 1: 0, eid: 3, flag: 0, deg: 3, tangent: 1 },
    { 0: 0.5562500000000001, 1: 0, eid: 9, flag: 0, deg: 3, tangent: 1 },
    { 0: 0.7187500000000001, 1: 0, eid: 13, flag: 1, deg: 3, tangent: 1 },
    { 0: 0.725, 1: 0.48125000000000007, eid: 14, flag: 1, deg: 3, tangent: 1 },
    { 0: 1, 1: 0.5062499999999999, eid: 7, flag: 0, deg: 3, tangent: 1 },
  ],
  deg: 3,
  eidgen: { _cur: 15 },
};
